import { createFilter, createSorter } from "components/Tables/ColumnCreationHelper";
import { t } from "i18next";
import { AppTableFilters } from "services/AppTableFilters";

export const appTableFiltersInstance = new AppTableFilters();

export const diagnosticsPackagesTableColumns = () => [
    {
        id: 'packageTags',
        Header: t('DiagnosticsPackages.Column.PackageTag'),
        accessor: 'packageTags',
        maxWidth: 80,
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "packageTags",
            t('DiagnosticsPackages.Column.PackageTag'),
        ),
    },
    {
        id: 'diagnosticsPackageId',
        Header: t('DiagnosticsPackages.Column.Id'),
        accessor: 'id',
        maxWidth: 80,
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "id",
            t('DiagnosticsPackages.Column.Id'),
        )
    },
    {
        id: 'diagnosticsName',
        Header: t('DiagnosticsPackages.Column.Name'),
        accessor: 'name',
        maxWidth: 80,
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "name",
            t('DiagnosticsPackages.Column.Name'),
        ),
    },
    {
        id: 'diagnosticsPackageEntryCount',
        Header: t('DiagnosticsPackages.Column.EntryCount'),
        accessor: 'entryCount',
        maxWidth: 70,
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "entryCount",
            t('DiagnosticsPackages.Column.EntryCount'),
        )
    },
    {
        id: 'diagnosticsPackageDescription',
        Header: t('DiagnosticsPackages.Column.Description'),
        accessor: 'description',
        maxWidth: 80,
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "description",
            t('DiagnosticsPackages.Column.Description'),
        )
    },
    {
        id: 'addedAtUtc',
        Header: t('DiagnosticsPackages.Column.AddedAt'),
        accessor: 'addedAtUtc',
        maxWidth: 60,
        sorter: createSorter(appTableFiltersInstance, 'addedAtUtc', 'date'),
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "addedAtUtc",
            t('DiagnosticsPackages.Column.AddedAt'),
        )
    },
    {
        id: 'actions',
        Header: t('actions'),
        maxWidth: 80,
    },
];
